import { useLoginStore, useAccountStore, useUserStore } from '@/stores'

/**
 * 获取令牌
 * @returns 
 */
export function getToken() {
    const store = useLoginStore()
    return store.token
}

/**
 * 获取登录ID
 * @returns 
 */
export function getLoginId() {
    const store = useLoginStore()
    return store.loginId
}

/**
 * 获取用户ID
 * @returns 
 */
export function getUserId() {
    const store = useLoginStore()
    return store.userId
}

/**
 * 获取账号ID
 * @returns 
 */
export function getAccountId() {
    const store = useAccountStore()
    return store.currentAccountId
}

/**
 * 获取所属会员ID
 * @returns 
 */
export function getMemberUserId() {
    const store = useUserStore()
    return store.memberUserId
}

/**
 * 获取账户类型
 * @returns 
 */
export function getUserInfoType() {
    const store = useUserStore()
    return store.userInfo.userinfotype
}